import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';

$("document").ready(function() {




});
 

